import * as React from "react";
import styles from "./TopBar.module.scss";
import { useFetch } from "../../../../hooks/useFetch.hook";
import SelectBox from "../../../Componnets/SelectBox/SelectBox";
import {getUniqueListBy} from "../../../../util/util";

const TopBar = ({ onSelectWorkspace }) => {
  const [selectedValue, setSelectedValue] = React.useState()
  const [page, setPage] = React.useState(1)
  const [workspaces, setWorkspaces] = React.useState([])
  const [searchResult, setSearchResult] = React.useState([])
  const [searchValue, setSearchValue] = React.useState()
  const [url, setUrl] = React.useState(`dashboard/workspace/?page=1`)

  const { data, status, refetch } = useFetch(url)

  const handleSelectValue = (value) => {
    setSelectedValue(value)
    onSelectWorkspace(value)
  }

  React.useEffect(() => {
    setWorkspaces([])
    setSelectedValue(null)
    setPage(1)
    setUrl(`dashboard/workspace/?page=1`)
    refetch()

    return () => {
      setWorkspaces([])
      setSelectedValue(null)
    }
  }, [])

  React.useEffect(() => {
    if (data?.results?.length) {
      const ws = (workspaces?.length && page !== 1) ? [...workspaces, ...data?.results] : data?.results
      setWorkspaces(ws)

      if (!selectedValue || !ws?.find(item => item.id === selectedValue?.value)) {
        handleSelectValue(ws?.map(item => ({title: item.name, value: item.id}))?.[0])
      }
    }
  }, [data?.results])

  const handleFetch = (searchValue) => {
    if (data?.results && page < data?.total_pages) {
      setUrl(`dashboard/workspace/?page=${page + 1}`)
      setPage(page + 1)
      if (searchValue) {
        setUrl(`dashboard/workspace/?page=${page + 1}&search=${searchValue}`)
      }
    }
  }

  return (
    <div className={'row mb-4'}>
      <div className={'col-md-12'}>
        <div className={styles.topBar}>
          <div className={styles.title}>
            Overview Dashboard
          </div>
          <div className={styles.selectBox}>
            <SelectBox
              style={{border: 0, boxShadow: "0 0 50px rgba(0, 0, 0, 0.07)"}}
              infiniteScroll
              onFetchData={() => handleFetch(searchValue)}
              searchStyle={"secondary"}
              singleSelect
              block
              options={workspaces?.map(item => ({title: item.name, value: item.id}))}
              dropDownValue={selectedValue}
              onSelectOption={handleSelectValue}
              searchByApi
              searchResult={searchResult}
              onSearchResult={(result, val) => {
                if (result) {
                  const sr = result?.data?.results?.map(item => ({title: item.name, value: item.id}))
                  searchResult?.length ? setSearchResult(getUniqueListBy([...searchResult, ...sr])) : setSearchResult(sr)
                  setSearchValue(val)
                  setPage(1)
                  setWorkspaces(sr?.map(item => ({name: item.title, id: item.value})))
                } else {
                  setWorkspaces([])
                  setSearchResult([])
                  setSearchValue(null)
                  setPage(1)
                  setTimeout(() => {
                    setUrl(null)
                  }, 0)
                  setTimeout(() => {
                    setUrl(`dashboard/workspace/?page=1`)
                  }, 0)
                  setTimeout(() => {
                    refetch()
                  }, 500)
                }
              }}
              propsSearchUrl={`dashboard/workspace?page=1&search`}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopBar